import script from "./StudentQA.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentQA.vue?vue&type=script&setup=true&lang=js"

import "./StudentQA.vue?vue&type=style&index=0&id=29e45378&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e45378"]])

export default __exports__